import { Injectable } from '@angular/core';
import { CivilStatus } from '../../models/civil-status.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable'

@Injectable()
export class CivilStatusService {

  private baseUrl = 'koncentro-customers';
  civilStatuses: CivilStatus[];
  civilStatusEditing: CivilStatus;
  private cachedFields: Observable<any>;

  constructor (
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  getList() {
    return this.http.get(`/${this.baseUrl}/civil-status`)
      .map(res => {
        return this.civilStatuses = res;
      });
  }

  delete(record) {
    return this.http.delete(`/${this.baseUrl}/civil-status/` + record.id)
      .map(res => {
        this.civilStatuses.splice(this.civilStatuses.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Civil status deleted'});
      });
  }

  post(newData) {
    return this.http.post(`/${this.baseUrl}/civil-status`, newData)
      .map(res => {
        newData.id = res.id;
        this.civilStatuses.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData, id) {
    return this.http.put(`/${this.baseUrl}/civil-status/` + id, newData)
      .map(res => {
        Object.assign(this.civilStatusEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get('/koncentro-customers/schema/CivilStatusDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/civil-status/civil-status.service.ts